<template>
  <div class="area-template" v-show="dialogVisible">
    <div class="mask foot-fixed">
      <el-dialog
        :visible.sync="dialogVisible"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="true"
        :modal="false"
        custom-class="dialog"
        :width="params.width || 'auto'"
        :center="true"
      >
        <div class="table-wrapper" slot="title">
          <el-table
            :data="tableData"
            :header-cell-style="{
              'background-color': '#f3f3f3'
            }"
            header-cell-class-name="theader-th"
            cell-class-name="tbody-td"
            :height="480"
          >
            <el-table-column align="center" width="100">
              <template slot-scope="scope">
                <el-radio v-model="id" :label="scope.row.id" />
              </template>
            </el-table-column>
            <el-table-column prop="id" align="center" width="180" label="ID" />
            <el-table-column
              prop="templateName"
              :label="params.templateName"
              align="center"
              width="180"
            />
            <el-table-column
              prop="area"
              align="left"
              :label="params.areaName"
              width="420"
            />
            <el-table-column
              v-if="params.firstItemName"
              :label="params.firstItemName"
              max-width="200"
            >
              <div slot-scope="scope">
                <div class="order-details">
                  <div class="img-show">
                    <el-button size="36" round class="iconfont icon-shangpin" />
                  </div>
                  <div class="info">
                    <span class="txt">首件</span>
                    {{ scope.row.firstItem }}
                  </div>
                  <div class="info">
                    <span class="txt">运费</span>
                    {{ scope.row.shipping | formatMoney }}
                  </div>
                </div>
              </div>
            </el-table-column>
            <el-table-column
              v-if="params.moreItemName"
              :label="params.moreItemName"
              max-width="250"
            >
              <div slot-scope="scope">
                <div class="order-details">
                  <div class="img-show">
                    <el-button size="36" round class="iconfont icon-shangpin" />
                    <i class="iconfont icon-tianjia" />
                    <span class="icon">
                      <i
                        class="iconfont icon-shangpin"
                        v-for="item in scope.row.moreItem"
                      />
                    </span>
                  </div>
                  <div class="info">
                    <span class="txt">续件</span>
                    {{ scope.row.moreItem }}
                  </div>
                  <div class="info">
                    <span class="txt">运费增加</span>
                    {{ scope.row.addShipping | formatMoney }}
                  </div>
                </div>
              </div>
            </el-table-column>
          </el-table>
          <Pagination
            v-if="pagination.recordTotal >= 1"
            :currentPage="pagination.currentPage"
            :totalPage="pagination.pageTotal"
            :totalRecord="pagination.recordTotal"
            :isPageSize="false"
            @handleNextPage="nextPage"
            @handlePrevPage="prevPage"
            @handleJumpPage="jumpPage"
          />
        </div>
        <div class="dialog-footer">
          <el-button size="98" @click="$emit('update:dialogVisible', false)">
            取消
          </el-button>
          <el-button class="sub-color" size="98" @click="saveTemplate">
            确 定
          </el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import pagination from 'mixins/pagination'
import updateData from 'mixins/updateData'

export default {
  name: 'AreaTemplate',
  inheritAttrs: false,
  mixins: [pagination, updateData],
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => []
    },
    pagination: {
      type: Object
    },
    params: {
      type: Object
    }
  },
  data() {
    return {
      id: ''
    }
  },
  watch: {
    params() {
      this.id = this.params.radioId
    }
  },
  methods: {
    /**
     * 保存模板
     */
    saveTemplate() {
      const { type, goodsMerchantId, goodsId, radioId } = this.params
      if (this.id === radioId) {
        this.$emit('update:dialogVisible', false)
        return
      }
      const data = {
        template_id: this.id,
        switch_type: type,
        goods_merchant_id: goodsMerchantId,
        goods_id: goodsId
      }
      this.api.swicthAreaTemplate(data).then(res => {
        this.$notify({
          type: 'success',
          message: '保存成功~！'
        })
        this.$emit('update:dialogVisible', false)
        this.$parent._refreshPage()
      })
    },
    /**
     * 调用父组件请求数据函数
     * @param vm
     * @param newValue
     * @param type
     * @private
     */
    _parentComponentRequest(vm, newValue, type) {
      if (this.params.type === 'sale') {
        vm._getSalesAreaList({ curpage: newValue })
      } else {
        vm._getTransportList({ curpage: newValue })
      }
    }
  }
}
</script>
<style lang="scss">
.area-template {
  .el-dialog__header {
    padding: 0;
  }

  .el-table {
    margin-bottom: 0 !important;
  }

  .el-dialog {
    max-height: 40rem;
  }

  .el-radio__label {
    opacity: 0;
  }

  .pagination {
    left: 0;
  }

  .order-details {
    .info {
      margin-top: 0.5rem;
    }

    .txt {
      font-size: 0.9rem;
      color: #333;
      font-weight: bold;
      margin-right: 0.5rem;
    }

    .icon-tianjia {
      background-color: transparent;
      margin: 0 0.3rem;
    }

    .img-show {
      display: flex;
      align-items: center;
    }

    .icon-shangpin {
      font-size: 24px;
    }

    .icon {
      width: 72px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
  }
}
</style>
